// src/data/sampleQuestions.js

export const SAMPLE_QUESTIONS = [
  "What is the best way to guide an associate whose speed is affecting the quality of their customer interactions?",
  "How can I help an associate who struggled to handle an extremely challenging customer call?",
  "How do I provide constructive feedback to an associate whose overly friendly approach is blurring professional boundaries?",
  "How can I support an associate in improving their emotional connection with customers despite strong technical performance?",
  "What is the most effective way to address an associate's difficulties in adapting to new technology?",
];

export const LOADING_MESSAGES = [
  "Thinking…",
  "Checking the knowledge base…",
  "Generating advice…",
  "Crafting your response…",
];
